const STORAGE_KEY_PREFIX = 'rcDfiToast:';

export const isDefaultFiltersInfoDismissed = (orderId: string): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(`${STORAGE_KEY_PREFIX}${orderId}`) === '1';
  } catch {
    return false;
  }
};

export const dismissDefaultFiltersInfo = (orderId: string) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(`${STORAGE_KEY_PREFIX}${orderId}`, '1');
  } catch {
    // ignore
  }
};
